import request from '@/utils/request'

const specialURL = {
  Create: '/topic/create',
  List: '/topic/list',
  Detail: '/article-author/detail',
  Update: '/topic/update',
  Delete: '/topic/delete',
  TopicList: '/topic/topic-article',
  CreateTopic: '/topic/relation-article',
  BatchTopic: '/topic/batch-relation-article',
  AutoLabelItems: '/label/auto-label-items',
  AutoLabelAudit: '/label/auto-label-audit',
}

// 添加专题
export function createSpecial (data) {
  return request({
    url: specialURL.Create,
    method: 'post',
    data
  })
}

// 专题列表
export function listSpecial (params) {
  return request({
    url: specialURL.List,
    method: 'get',
    params
  })
}

// 编辑专题
export function updataSpecial (data) {
  return request({
    url: specialURL.Update,
    method: 'post',
    data
  })
}

// 删除专题
export function deleteSpecial (data) {
  return request({
    url: specialURL.Delete,
    method: 'post',
    data
  })
}

// 关联列表
export function listTopic (params) {
  return request({
    url: specialURL.TopicList,
    method: 'get',
    params
  })
}

// 关联文章
export function createTopic (data) {
  return request({
    url: specialURL.CreateTopic,
    method: 'post',
    data
  })
}

// 刷新关联列表
export function batchTopic (data) {
  return request({
    url: specialURL.BatchTopic,
    method: 'post',
    data
  })
}

//  标签匹配文章列表
export function autoLabelItems (data) {
  return request({
    url: specialURL.AutoLabelItems,
    method: 'post',
    data
  })
}

// 标签匹配文章列表_操作
export function autoLabelAudit (data) {
  return request({
    url: specialURL.AutoLabelAudit,
    method: 'post',
    data
  })
}

export default {
  createSpecial,
  listSpecial,
  updataSpecial,
  deleteSpecial,
  listTopic,
  createTopic,
  batchTopic,
  autoLabelItems,
  autoLabelAudit
}
